import React from 'react'

const OverviewCard = (props) => {
  return (
    <div className={`${props.overviewCardBorder} overview-card`}>
        <img className='overview-card-img' src={props.src} alt={props.alt} />
        <div className="overview-card-info">
            <p className="overview-card-title">{props.title}</p>
            <h3 className="overview-card-subTitle"><span  >{props?.prefix}</span> {props.subTitle?.toLocaleString()}</h3>
        </div>
        {/* <p className={`${props.class} profitAndLoss`}>{props.profitAndLoss}% <img src={props.profitAndLossIconSrc} alt={props.profitAndLossalt} /></p> */}
    </div>
  )
}

export default OverviewCard